module.exports = __webpack_public_path__ + "img/home.f8826574.svg";